import { ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT, THE_POST_WAS_BLOCKED } from 'mk/autogenerated/translations/app.db8376b52bc51e5be2bd93814f908999'
import { jQuery as $ } from 'mk/jQuery';
import { mountOldAndroidAnnouncementBox } from 'mk2/apps/blogs/miniapps';
import * as album from './album';
import * as comment2 from './comment2';
import deletePost from './deletePost';
import editPost from './editPost';
import * as flaggedCounts from './flaggedCounts';
import * as imagetitle from './imagetitle';
import renderMessageForm from './renderMessageForm';
import * as snippets from './snippets';
import * as truncateShortMessage from './truncateShortMessage';
import unmountMessageForm from './unmountMessageForm';
import * as userStrollers from './userStrollers';

declare const window: any;

window.mk__photoblog__photoblog = {
    comment2,
    userStrollers,
    imagetitle,
    snippets,
    deletePost,
    editPost,
    flaggedCounts,
    truncateShortMessage,
    album,
    renderMessageForm,
    unmountMessageForm,
    mountOldAndroidAnnouncementBox,
    translations: {
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT,
        THE_POST_WAS_BLOCKED,
    },
};

$(window).on('load', truncateShortMessage.onLoad);
